/* eslint-disable no-param-reassign */
import makeExtendedData from 'utils/makeExtendedStatisticsData';
import { getDeeperValue } from './helpers';

const setFullNameInArray = (data, fromField) => {
  if (Array.isArray(data)) {
    let fullName = '';
    const transformedItems = data.map(item => {
      const info = getDeeperValue(fromField, item);
      if (info) {
        fullName = `${info.firstName} ${info.lastName}`;
      }
      return {
        ...item,
        fullName,
      };
    });

    return transformedItems;
  }
  return data;
};

export const addFullNameField = (data, fromField) => {
  let returnData = data;
  if (data.items) {
    const transformedItems = setFullNameInArray(data.items, fromField);
    returnData = {
      ...data,
      items: transformedItems,
    };
  } else {
    returnData = setFullNameInArray(data, fromField);
  }

  return returnData;
};

export const tasksModifier = data => {
  const updatedData = data.jobTasks.map(item => {
    item.isPerformed = item.performed ? 'performed' : 'notPerformed';
    item.jobTask = item.name;
    return item.name;
  });
  return { ...data, updatedData };
};

export const dashboardModifier = data => ({
  ...data,
  ...data.table,
});

export const trainingSessionStatisticsModifier = data => {
  const dataExtended = makeExtendedData(data.table.items);
  return {
    ...data,
    statData: {
      items: dataExtended,
      totalCount: data.table.count,
    },
  };
};

export const scheduledTrainingSessionsModifier = data => {
  let transformedScheduledSessions = [];

  if (data.global) {
    const globalSessions = data.global.map(session => ({
      ...session,
      sessionType: 'global',
    }));

    transformedScheduledSessions = [...transformedScheduledSessions, ...globalSessions];
  }

  if (data.local) {
    const localSessions = data.local.map(session => ({
      ...session,
      sessionType: 'local',
    }));
    transformedScheduledSessions = [...transformedScheduledSessions, ...localSessions];
  }

  if (!data.global && !data.local && Array.isArray(data.items)) {
    return data.items;
  }

  return transformedScheduledSessions;
};

export const jobTasksModifier = data => {
  const jobTasks = data.items.map(item => {
    const firstName = item?.updatedByUser?.info?.firstName || '';
    const lastName = item?.updatedByUser?.info?.lastName || '';
    return {
      ...item,
      fullName: `${firstName} ${lastName}`.trim(),
      // Preserve companyId to identify system job tasks (companyId = 0)
      companyId: item.companyId,
    };
  });
  return { ...data, items: [...jobTasks] };
};

export const pastCoursesModifier = data => {
  const dataExtended = data.items.map(item => ({
    ...item,
    buttonParams: {
      id: item.id, // Course ID for certificate handling
      certificate: item.certificate || null,
      isPerformedWithSuccess: item.studentPerformedState ? item.studentPerformedState.isPerformedWithSuccess : null,
      isMoodleCourse: !!item.isMoodleCourse,
      status:
        item.status ||
        (item.studentPerformedState?.isPerformedWithSuccess === true
          ? 'Passed'
          : item.studentPerformedState?.isPerformedWithSuccess === false
          ? 'Failed'
          : 'Pending'), // Add status field for display
      isFrozen: item.isFrozen || false, // Add isFrozen field if needed
    },
  }));
  return { ...data, items: dataExtended };
};

export const documentsModifier = data => {
  const dataUpdated = data.map(item => ({
    ...item,
    byWhom: `${item.uploadedBy.info.firstName} ${item.uploadedBy.info.lastName}`,
  }));
  return { items: dataUpdated };
};
